export enum RouteKeys {
  homePage = 'home',
  offers = 'offers',
  trends = 'trends',
  users = 'users',
  userStat = 'user-statistics',
  countryStat = 'country-statistics',
  hostCountries = 'host-countries',
  rtb = 'rtb',
  hosts = 'hosts',
  settings = 'settings',
  user = 'user',
  signIn = 'sign-in',
  partners = 'partners',
  ltv = 'ltv',
  createUser = 'create-user',
  createOffer = 'create-offer',
  createPartner = 'create-partner',
  adminPanel = 'admin-panel',
}

export const BASE_ROUTE = '/';

export const baseRoutes = {
  user: `/${RouteKeys.user}`,
};

export const webAppRoutes = {
  // ProgramRoutesModel
  home: '/',
  adminPanel: `/${RouteKeys.adminPanel}`,
  offers: `/${RouteKeys.offers}`,
  trends: `/${RouteKeys.trends}`,
  userStat: `/${RouteKeys.userStat}`,
  countryStat: `/${RouteKeys.countryStat}`,
  rtb: `/${RouteKeys.rtb}`,
  hosts: `/${RouteKeys.hosts}`,
  hostCountries: `/${RouteKeys.hostCountries}`,
  hostByCountries: `/${RouteKeys.hosts}/by-countries`,
  partners: `/${RouteKeys.partners}`,
  ltv: `/${RouteKeys.ltv}`,
  settings: `/${RouteKeys.settings}`,
  createUser: `/${RouteKeys.createUser}`,
  createOffer: `/${RouteKeys.createOffer}`,
  createPartner: `/${RouteKeys.createPartner}`,
  notFound: '/404',

  user: baseRoutes.user,
  signIn: `${baseRoutes.user}/sign-in`,
  userPage: `/${RouteKeys.users}`,
};
